import { useCallback } from 'react';

export const useIntercomArticle = (articleId) => {
  return useCallback(() => {
    if (window.Intercom) {
      window.Intercom('showArticle', articleId);
    }
  }, [articleId]);
};
